import { HelpMessage } from 'utils/constants'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { useBreakDateByPlacementDate } from '../../../../../useBreakDateByPlacementDate'
import BreakDataTable from '../../../BreakDataTable'
import { ConcreteTest } from '../../types'
import FirstTable from './components/FirstTable'
import SecondTable from './components/SecondTable'

/**
 * @param placementDate ISO 8601 date string
 */
export function useExpand(
  placementDate: string | null
): ExpandOptions<ConcreteTest> {
  const breakDate = useBreakDateByPlacementDate(placementDate)
  return {
    render: (record) => {
      const breakData = !!record.concreteTestBreakData.length
        ? record.concreteTestBreakData
        : record.strengthAges.map<ConcreteTest['concreteTestBreakData'][0]>(
            (age) => ({
              __typename: 'ConcreteTestBreakData',
              age,
              id: Math.random(),
              breakDate: breakDate(age)?.toISOString() ?? null,
              diameter: null,
              labNumber: null,
              labTech: null,
              peakLoad: null,
              strength: null,
              testingLab: null,
              type: null,
            })
          )
      return {
        custom: [
          { children: <FirstTable {...record} /> },
          {
            children: (
              <BreakDataTable
                breakData={breakData}
                rowKey="id"
                help={
                  HelpMessage.Concrete.ConcreteTestSetTracker.BreakData.Cylinder
                }
                diameter={{ title: 'Diameter/Size', width: 159 }}
              />
            ),
          },
          { children: <SecondTable {...record} /> },
        ],
      }
    },
  }
}
